import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const MoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 14a2 2 0 1 1 0-4 2 2 0 1 1 0 4zM12 14a2 2 0 1 1 0-4 2 2 0 1 1 0 4zM18 14a2 2 0 1 1 0-4 2 2 0 1 1 0 4z"
      className="primary"
    />
  </svg>
);
export default withCustomIcon(MoreIcon);
